import * as S from "./Error.style";

const Error = () => {
  return (
    <S.ErrorLayout>
      <S.ErrorText>에러가 발생했습니다.</S.ErrorText>
    </S.ErrorLayout>
  );
};

export default Error;
